import {
  FINDINGS_SLUG,
  STUDY_DOC_SLUG,
  ThreadArtifactItem,
} from './collectThreadArtifacts'
import { parseGateQuestions } from './gateArtifacts'

/**
 * Artifacts the thread column may show under the conversation.
 *
 * Questions payloads belong in the rail only (`parseGateQuestions` is the
 * body-shape predicate — never a title string). THE POET StudyDoc is owned
 * by `ThreadRunResults` (same chrome, plots + cut picker) so it is omitted
 * here to avoid a second card. Findings are already dropped in
 * `collectThreadArtifacts`; the kind/slug checks here are a backstop for
 * any synthesized item that still carries that identity.
 */
export function filterInlineThreadArtifacts(
  items: Array<ThreadArtifactItem>,
): Array<ThreadArtifactItem> {
  return items.filter((item) => {
    if (
      item.kind === 'study_doc' ||
      item.kind === 'findings' ||
      item.slug === STUDY_DOC_SLUG ||
      item.slug === FINDINGS_SLUG
    ) {
      return false
    }
    if (item.kind === 'stimulus') {
      return false
    }
    return parseGateQuestions(item.body) === null
  })
}
